import {useComputed} from "@preact/signals-react";
import {useAppToast} from "@ui-seeker/app";
import { scrollToComponent, postSubmit } from "@ui-seeker/utils"

import { commonFiltersValue } from "@signals";
import { adminProductReviewFormIsSkuMappingData } from "../@signals/form";
import { useCallback } from "react";
import { WEBBACK_V2_API } from "@constants";

export default function useAdminProductReviewListNew(rowData={}, date=null, siteID=null, productID=null, skuID=null) {
	const { showToast } = useAppToast()

	const handleClickSkuMapping = useCallback(() =>  {
		showToast.promise(postSubmit(`${WEBBACK_V2_API}/admin/product-review-new/raw-data`, {...commonFiltersValue.value, retailer: [], sku:[rowData.skuID]}).then(({ table, detail }) => {
			adminProductReviewFormIsSkuMappingData.value = table
		}).catch(() => {showToast.error()})
		.finally(() => scrollToComponent('product-review-sku-mapping-table')))
	}, [JSON.stringify(rowData)])
    
	const tableData = useComputed(() => {
		if (adminProductReviewFormIsSkuMappingData.value === null)
			return []
		return adminProductReviewFormIsSkuMappingData.value
	})

	return {
		showTable: !!tableData.value.length,
		tableData: tableData.value,
		handleClickSkuMapping
	}
}